import React, { Component } from 'react';
const classNames = require('classnames');

import './switch.styl';

class Switch extends Component {
  constructor(props) {
    super(props);

    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleMouseUp = this.handleMouseUp.bind(this);
    this.toggle = this.toggle.bind(this);
    this.setChecked = this.setChecked.bind(this);

    this.state = {
      checked: typeof this.props.checked !== 'undefined' && !!this.props.checked
    };
  }

  componentDidUpdate() {
    if (this.props.checked && !this.state.checked) {
      this.setState({ checked: true });
    } else if (!this.props.checked && this.state.checked) {
      this.setState({ checked: false });
    }
  }

  setChecked(checked) {
    this.setState({ checked });
    this.props.onChange && this.props.onChange(checked);
  }

  toggle() {
    const checked = !this.state.checked;
    this.setChecked(checked);
  }

  handleKeyDown(e) {
    if (e.keyCode === 37) {
      this.setChecked(false);
    }
    if (e.keyCode === 39) {
      this.setChecked(true);
    }
  }
  // Handle auto focus when click switch in Chrome
  handleMouseUp(e) {
    if (this.refs.switch) {
      this.refs.switch.blur();
    }
    if (this.props.onMouseUp) {
      this.props.onMouseUp(e);
    }
  }

  render() {
    const {
      className,
      disabled,
      checkedChildren,
      unCheckedChildren,
      ...restProps
    } = this.props;
    const checked = this.state.checked;
    const switchClassName = classNames('switch-component', {
      [className]: !!className,
      [`switch-component-checked`]: checked,
      [`switch-component-disabled`]: disabled
    });

    return (
      <span
        {...restProps}
        ref="switch"
        className={switchClassName}
        tabIndex="0"
        onKeyDown={this.handleKeyDown}
        onClick={disabled ? noop : this.toggle}
        onMouseUp={this.handleMouseUp}
      >
        <span className="switch-component-inner">
          {checked ? checkedChildren : unCheckedChildren}
        </span>
      </span>
    );
  }
}

export default Switch;
